angular.module('impactx.stockwithdrawal').controller('StockWithdrawalExpensedListCtrl', [
    'selectedListItems',
    '$mdDialog',
    '$scope',
    'ListHelperService',
    'dataGen',
    StockWithdrawalExpensedListController
]);

function StockWithdrawalExpensedListController(selectedListItems, $mdDialog, $scope, ListHelperService, dataGen) {
    var self = this;

    this.showUnbookButton = function(){
        return selectedListItems.isMultiSelection() && impactX.isDefined(self.getMeta(),"actions.unbook.allowed");
    };

    this.unbookStockWithdrawal = function(event){
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm({}, {ids: selectedListItems.getSelectedIds()}, '/stockwithdrawal/unbook/info').then(function (data) {
            return $mdDialog.show({
                    controller: 'UnbookStockWithdrawalCtrl',
                    controllerAs: 'unbookStockWithdrawalCtrl',
                    templateUrl: 'modules/stockwithdrawal/templates/unbook-stock-withdrawal-dialog.html',
                    targetEvent: event,
                    clickOutsideToClose: false,
                    bindToController: true,
                    parent: angular.element(document.body),
                    locals: {
                        dniInfoIds: selectedListItems.getSelectedIds(),
                        dniInfoData: data.data,
                        trns: data.trns
                    }
                }
            ).then(function (result) {
                ListHelperService.refreshListData($scope, 'stockWithdrawalExpensedListCtrl', {unselectRows: selectedItems});
            })
        });
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewStockWithdrawal'
        },
        {
            label: "unbook",
            action: self.unbookStockWithdrawal,
            condition: self.showUnbookButton,
            process: 'UnbookStockWithdrawal'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/stockwithdrawal/templates/stock-withdrawal-list-expensed.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/stockwithdrawal/list/expensed',
        id: "stockwithdrawalexpensed",
        buttonDefinition: buttonDefinition
    };

    self.getMeta = function () {
        return self.meta;
    };

    function getDetailLink() {
        return "stockwithdrawal/" + selectedListItems.getFirstSelectedId() + "/0";
    }
}